<template>
  <nav class="col-8">
    <ul class="nav">
      <navigation-item
        v-for="item in navigation.items"
        :key="item.title"
        :title="item.title"
        :href="item.href"
      ></navigation-item>
    </ul>
  </nav>
</template>

<script>
import NavigationItem from "./item.vue";
export default {
  data: function() {
    return {
      navigation: {
        items: [
          {
            title: "O mne",
            href: "#about"
          },
          {
            title: "Projekty",
            href: "#projects"
          },
          {
            title: "Kontakt",
            href: "#contact"
          }
        ]
      }
    };
  },
  components: {
    NavigationItem
  }
};
</script>

<style>
</style>
